import Axios from "axios";
import axiosClient from "./axiosClient";
const BaseURL: string = process.env.REACT_APP_API_URL ?? "";

type IReqBody = {
  bookingNumber: string;
  name: string;
  email: string;
  problem: string;
};

async function saveNewMidocoTask(reqBody: IReqBody) {
  try {
    const response = await axiosClient.post(
      `/notices/SaveOrderNoticeRequest`,
      reqBody
    );

    if (response.status !== 200) {
      console.warn(`api call response is not 200 ok!`);
      return null;
    }
    return response.data;
  } catch (error: any) {
    console.log(error);
    return null;
  }
}

export default saveNewMidocoTask;
